import { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { Helmet } from 'react-helmet';
import { ApplicationState } from '../../../../../store';
import * as StudentActions from '../../../../../store/student/actions';
import * as VPFActions from '../../../../../store/student/visaPrepForm/actions';
import QuestionPage from '../../../../templates/question';
import { VQ } from '../../../../../store/student/types';
import { TextareaWithConfirm, TitleAndEditButton } from 'shared-components';
import {
  createNavigateBackwardAction,
  createNavigateForwardAction,
  createNavigateToAction
} from '../../../../../middleware/actions';
import { Pages } from '../../../../../store/student/visaPrepForm/types';
import { getPageStatus } from './utils';
import { toggleTaskMenu } from '../../../../../store/ui/actions';
import { titleAppend } from '../../../../../utilities/head';

const VisaPrepFormAddHistoryPage1 = () => {
  // dispatch actions
  const dispatch = useDispatch();
  const onPrevious = () => dispatch(createNavigateBackwardAction());
  const onNext = () => {
    dispatch(StudentActions.saveVisaPrepForm(Pages.PAGE2_1));
    dispatch(createNavigateForwardAction());
  };
  const onSkip = () => dispatch(createNavigateForwardAction());
  const onChange = (fieldName: string, value: any, refValue?: any) =>
    dispatch(VPFActions.createUpdateVPIFieldAction(fieldName, value, refValue));
  const onBackToTaskList = () => {
    dispatch(createNavigateToAction('/dashboard'));
    dispatch(toggleTaskMenu(false));
  };
  const onEdit = () => dispatch(createNavigateToAction('/history/step-3'));

  // state props from store
  const nonHomeCountryApplicationDesc = useSelector(
    ({ student }: ApplicationState) => student.visa.nonHomeCountryApplicationDesc,
    shallowEqual
  );

  // constants
  const currentStep = 1;
  const steps = 8;
  const sectionTitle = 'Additional History';

  // component state
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    const { complete: newComplete } = getPageStatus({
      nonHomeCountryApplicationDesc
    });
    if (newComplete !== complete) {
      setComplete(newComplete);
    }
  }, [complete, nonHomeCountryApplicationDesc]);

  const onNonHomeCountryAppDescChange = (evt: any) => {
    onChange(VQ.NON_HOME_COUNTRY_APP_DESC, evt.currentTarget.value);
  };

  return (
    <QuestionPage
      complete={complete}
      currentStep={currentStep}
      steps={steps}
      onPrevious={onPrevious}
      onNext={onNext}
      onSkip={onSkip}
      onBackToTaskList={onBackToTaskList}
      section={sectionTitle}
    >
      <Helmet>
        <title>
          {`${sectionTitle}: Step ${currentStep}`} {titleAppend}
        </title>
      </Helmet>

      <TitleAndEditButton title="You indicated that you are not applying from your home country" onClick={onEdit} />

      <TextareaWithConfirm
        key={VQ.NON_HOME_COUNTRY_APP_DESC}
        id={VQ.NON_HOME_COUNTRY_APP_DESC}
        value={nonHomeCountryApplicationDesc}
        label={
          'Please explain your visa/immigration status for the country you are applying from, and the expiry date of any visas you hold for this country'
        }
        onChange={onNonHomeCountryAppDescChange}
      />
    </QuestionPage>
  );
};
export default VisaPrepFormAddHistoryPage1;
